export default __webpack_public_path__ + "static/media/suk-it-frogz.373c3ddc.gif";